(function() {
  const isDesktop = !window.matchMedia('(max-width: 1140px)').matches;
  if (!isDesktop) return;

  const megaTemplates = document.querySelectorAll('template[xo-mega-menu-name]');
  if (!megaTemplates.length) return;

  const megaIndices = new Set();
  megaTemplates.forEach(function(t) {
    megaIndices.add(t.getAttribute('xo-mega-menu-index'));
  });

  const sticky = document.querySelector('xo-sticky.xo-header__body');
  if (!sticky) return;

  document.querySelectorAll('.xo-menu-horizontal__item--first').forEach(function(item) {
    const mega = item.querySelector('xo-mega-menu');
    if (!mega || !megaIndices.has(mega.getAttribute('xo-index'))) return;

    item.addEventListener('mouseenter', function() {
      const inner = sticky.shadowRoot
        ? sticky.shadowRoot.querySelector('[part="inner"]')
        : sticky.querySelector(':scope > *');
      if (inner) inner.setAttribute('xo-is-sticky', 'true');
      sticky.setAttribute('xo-is-sticky', 'true');
    });
  });

  let savedScrollY = 0;
  let locked = false;

  const lockScroll = function() {
    if (locked) return;
    locked = true;
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };

  const unlockScroll = function() {
    if (!locked) return;
    locked = false;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);
  };

  document.querySelectorAll('.xo-menu-horizontal__item--first').forEach(function(item) {
    const mega = item.querySelector('xo-mega-menu');
    if (!mega || !megaIndices.has(mega.getAttribute('xo-index'))) return;

    item.addEventListener('mouseenter', lockScroll);
    item.addEventListener('mouseleave', unlockScroll);
  });
})();
